<template>
  <div class="card-inner">
    <template v-if="showCheckbox">
      <div
        v-if="
          data.ManpowerDemandStatus === 'New' ||
          data.ManpowerDemandStatus === 'Pending'
        "
        class="check-wrap"
        @click="$refs.check.click()"
      >
        <input
          ref="check"
          type="checkbox"
          :checked="data.isChecked"
          v-model="data.isChecked"
          @click="clickCheck(data)"
        />
        <span>
          <i class="fas fa-check" />
        </span>
      </div>
    </template>

    <div
      class="detail-header"
      :style="{ 'background-color': headerBackgroundColor }"
    >
      <div class="text-wrap">
        <span class="title">{{ data.ManpowerDemandName }}</span>
        <span class="number">{{ data.No }}</span>
        <span class="status">
          {{ $common.manpowerDemandStatusFormatter(data.ManpowerDemandStatus) }}
        </span>
      </div>
    </div>
    <div class="detail-info">
      <ul>
        <li>
          <eva-icon name="person-outline" />
          <span>{{ data.Applicant }}</span>
        </li>
        <li>
          <eva-icon name="monitor-outline" />
          <span>{{ data.DemandDepartment }}</span>
        </li>
        <li>
          <eva-icon name="pricetags-outline" />
          <span>{{ data.PositionName }}</span>
        </li>
        <li>
          <eva-icon name="eye-outline" />
          <span>{{ data.DemandNumber }} 人</span>
        </li>
        <li>
          <eva-icon name="clock-outline" />
          <span>
            {{ $common.dateFormatter(data.ApplicantTime) }}
            ~
            {{ $common.dateFormatter(data.RecruitmentDeadline) }}</span
          >
        </li>
        <li v-if="category === 'apply' || category === 'search'">
          <eva-icon name="edit-outline" />
          <span>{{ data.Approver }}</span>
        </li>
      </ul>
    </div>
    <div class="button-group">
      <template>
        <button type="button" class="btn" @click="viewDemand(data.No)">
          檢視
        </button>
      </template>
      <!-- 需求申請 -->
      <slot name="apply" :props="data"></slot>

      <!-- 需求查詢 -->
      <slot name="search" :props="data"></slot>

      <!-- 需求審核 -->
      <slot name="review" :props="data"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["category", "data", "showCheckbox"],

  name: "DemandCard",
  data() {
    return {
      chooseDemand: [],
      headerBackgroundColor: "",
    };
  },

  watch: {
    "data.ManpowerDemandStatus": function (e) {
      switch (e) {
        case "New":
          this.headerBackgroundColor = "#008800";
          break;
        case "Pending":
          this.headerBackgroundColor = "#ffc00e";
          break;
        case "Approved":
          this.headerBackgroundColor = "#5380f7";
          break;
        case "Rejected":
          this.headerBackgroundColor = "#ec1a1a";
          break;
        case "Suspend":
          this.headerBackgroundColor = "#9b70c2";
          break;
        case "Cancelled":
          this.headerBackgroundColor = "#7B7B7B";
          break;
      }
    },
  },

  methods: {
    // 選取需求單
    clickCheck(data) {
      this.$emit("updateSelectDemand", data);
    },

    // 檢視需求單
    viewDemand(demandNo) {
      this.$store.commit("OpenDemandDetailModal", demandNo);
    },
  },

  mounted() {
    switch (this.data.ManpowerDemandStatus) {
      case "New":
        this.headerBackgroundColor = "#008800";
        break;
      case "Pending":
        this.headerBackgroundColor = "#ffc00e";
        break;
      case "Approved":
        this.headerBackgroundColor = "#5380f7";
        break;
      case "Rejected":
        this.headerBackgroundColor = "#ec1a1a";
        break;
      case "Suspend":
        this.headerBackgroundColor = "#9b70c2";
        break;
      case "Cancelled":
        this.headerBackgroundColor = "#7B7B7B";
        break;
    }
  },
};
</script>
